import ReportPage from './ReportPage.page';

export default ReportPage;
